// src/components/GiftUsButton.js
import React from "react";
import "./GiftUsButton.css";

const GiftUsButton = ({ onClick }) => {
  return (
    <button className="gift-us-button" onClick={onClick}>
      🎁 Gift Us
    </button>
  );
};

export default GiftUsButton;
